import React from "react";
import { ShieldCheck, ShieldAlert, Loader2 } from "lucide-react";

export const KatlasStatusPill = ({ status }) => {
    if (!status) {
        return (
            <div
                data-testid="katlas-status-pill"
                className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500"
            >
                <Loader2 className="h-3 w-3 animate-spin" />
                Checking KATLAS…
            </div>
        );
    }

    const isActive = status.status === "active" && status.node_reachable;
    const isDegraded = status.status === "degraded";
    const isUnconfigured = status.status === "unconfigured";

    const palette = isActive
        ? {
              wrap: "border-emerald-200 bg-emerald-50 text-emerald-800",
              dot: "bg-emerald-500 text-emerald-500",
              icon: <ShieldCheck className="h-3.5 w-3.5" />,
          }
        : isDegraded
        ? {
              wrap: "border-amber-200 bg-amber-50 text-amber-800",
              dot: "bg-amber-500 text-amber-500",
              icon: <ShieldAlert className="h-3.5 w-3.5" />,
          }
        : {
              wrap: "border-amber-200 bg-amber-50 text-amber-800",
              dot: "bg-amber-500 text-amber-500",
              icon: <ShieldAlert className="h-3.5 w-3.5" />,
          };

    return (
        <div
            data-testid="katlas-status-pill"
            data-status={status.status}
            className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em] ${palette.wrap}`}
        >
            <span className={`relative inline-block h-2 w-2 rounded-full dot-pulse ${palette.dot}`} />
            {palette.icon}
            <span className="font-medium">{status.label}</span>
            {isUnconfigured && (
                <span className="ml-1 hidden sm:inline text-slate-500/80 normal-case tracking-normal font-sans">
                    · honest unconfigured state
                </span>
            )}
        </div>
    );
};

export default KatlasStatusPill;
